import { LogSeverity } from './enums/log-severity';

export class LogSupervisionEntry {
    source: string;
    date: Date;
    severity: LogSeverity;
    sessionId: string;
    userId: string;
    userDisplayName: string;
    organizationId: string;
    message: string;
    domain: string;

    public createCopy(): LogSupervisionEntry {
        const instance = new LogSupervisionEntry();
        instance.source = this.source;
        instance.date = this.date;
        instance.severity = this.severity;
        instance.sessionId = this.sessionId;
        instance.userId = this.userId;
        instance.userDisplayName = this.userDisplayName;
        instance.organizationId = this.organizationId;
        instance.message = this.message;
        instance.domain = this.domain;

        return instance;
    }

    public copyFrom(other: any) {
        this.source = other.source;
        this.date = other.date;
        this.severity = other.severity;
        this.sessionId = other.sessionId;
        this.userId = other.userId;
        this.userDisplayName = other.userDisplayName;
        this.organizationId = other.organizationId;
        this.message = other.message;
        this.domain = other.domain;
    }
}
